var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4375 14V22.5547C37.4375 24.0078 37.2734 25.2891 36.9453 26.3984C36.6328 27.5078 36.1875 28.4297 35.6094 29.1641C35.0312 29.8984 34.3281 30.4531 33.5 30.8281C32.6719 31.2031 31.75 31.3906 30.7344 31.3906C29.7031 31.3906 28.7734 31.2031 27.9453 30.8281C27.1328 30.4531 26.4297 29.8984 25.8359 29.1641C25.2578 28.4297 24.8047 27.5078 24.4766 26.3984C24.1641 25.2891 24.0078 24.0078 24.0078 22.5547V14H26.8672V22.2734C26.8672 23.5547 26.9531 24.6328 27.125 25.5078C27.3125 26.3828 27.5703 27.0859 27.8984 27.6172C28.2266 28.1328 28.625 28.5078 29.0938 28.7422C29.5625 28.9766 30.0859 29.0938 30.6641 29.0938C31.2578 29.0938 31.7969 28.9844 32.2812 28.7656C32.7656 28.5469 33.1797 28.1797 33.5234 27.6641C33.8672 27.1484 34.1328 26.4531 34.3203 25.5781C34.5078 24.7031 34.6016 23.6016 34.6016 22.2734V14H37.4375Z",
    fill: "#933333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8672 14L15.7344 24.2422V31.2734H12.875V24.4766L8 14H11.2109L14.1875 21.7344H14.4453L17.6562 14H20.8672Z",
    fill: "#933333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/sr.27503067c5ecd86667edb8864d17c7c2.svg";
export { ForwardRef as ReactComponent };